import React from 'react'
import UserPage from "./UserPage"

function UserContainer() {
    return (
        <div className="UserContainer">
            <UserPage/>
        </div>
    )
}

export default UserContainer